import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
import SharedData from '../common/SharedData'
import {getPackageSalesSummary, IPackageSalesSummary} from './core/_requests'

/**
 * Small summary of the supplier's package activity: how many of their own
 * packages sold, and how many of their component units went out inside a
 * package vs standalone. Self-contained (fetches on mount); renders nothing
 * until there is any package activity, so suppliers with no packages see no
 * extra clutter.
 */
const PackageSalesSummaryCard: React.FC = () => {
  const {formatMessage} = useIntl()
  const {currentUser, language} = SharedData()
  const [summary, setSummary] = useState<IPackageSalesSummary | null>(null)

  useEffect(() => {
    let active = true
    getPackageSalesSummary(currentUser?.token, language)
      .then((res) => {
        if (active) setSummary(res.data.data)
      })
      .catch(() => {
        /* silent — the sales table is the primary content */
      })
    return () => {
      active = false
    }
  }, [])

  const t = (id: string, defaultMessage: string) => formatMessage({id, defaultMessage})

  if (!summary) return null
  if (!summary.packages_sold && !summary.units_via_package) return null

  const cards = [
    {label: t('pkg_report_packages_sold', 'Packages sold'), value: summary.packages_sold},
    {label: t('pkg_report_units_via_package', 'Units sold via packages'), value: summary.units_via_package},
    {label: t('pkg_report_units_standalone', 'Units sold standalone'), value: summary.units_standalone},
  ]

  return (
    <div className='row g-3 mb-4'>
      {cards.map((c) => (
        <div className='col-sm-4' key={c.label}>
          <div className='card h-100' style={{border: '1px solid #E4E6EF', borderRadius: 12}}>
            <div className='card-body py-4'>
              <div className='text-muted fs-7'>{c.label}</div>
              <div className='fs-2 fw-bold mt-1'>{c.value}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default PackageSalesSummaryCard
